<template>
	<div class="mt-3">
		<div>
			<CustomLoader v-if="isLoading" :width="70"></CustomLoader>
			<!-- <Loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></Loading> -->
		</div>

		<b-navbar class="formCard" style="border-radius: 5px !important; padding-left: 0px" toggleable="lg" type="dark"
			variant="primary">
			<b-button @click="previousSalesView" size="sm" variant="light">
				<md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
			</b-button>

			<b-navbar-brand center>Expense</b-navbar-brand>

		</b-navbar>

		<banner-component 
			:allModuleIdBanner="$route.params.allModuleId ? $route.params.allModuleId : ''"
			:jobSeriesBanner="Filter.AssNo ? Filter.AssNo : ''" 
			:bannerClientName="Filter.TPTClient ? Filter.TPTClient : ''"
			iconId="fa fa-ship" 
		/>

		<b-card class="mainCardBG">
			<b-card-text>
				<Splitmerge-Summary 
					:SM_Status="2" 
					:title="'All Container Track - '"
					:SM_all_module_id="allModuleId"
					:SM_jb_series="Filter.AssNo" class="mt-2"
				/>

				<b-button v-if="(allpurchasesList.length > 0 && Filter.finalBillingCompleted == '0') ||
					((Filter.finalBillingCompleted == '1') &&
						allpurchasesList[0].closedOverseasStatus == 'Overseas Closed' &&
						allpurchasesList[0].billingType == 'Overseas Billing')" size="sm" variant="outline-dark" @click="showQuotation"
					class="pull-right">
					Show Quotation
				</b-button>


				<!-- Additional Task Table -->
				<!-- {{ otherAdditionalTask_Data }} <br> -->
				<!-- {{ selectedATDRows }} <br> -->
				<div class="gutr">
					<h5> <b-badge variant="info">Additional Task Request</b-badge> </h5>
					<div class="table-responsive tableMain">
						<b-table 
							show-empty stacked="md" 
							:items="otherAdditionalTask_Data" 
							:fields="AdditionalTaskFields"
						>
							<template slot="select" slot-scope="row0">
								<b-form-checkbox :id="'checkboxATD_' + row0.index" :value="row0.item" v-model="selectedATDRows"
									@change="addToFinalTable(row0.item)"></b-form-checkbox>
							</template>

							<template slot="sn" slot-scope="row1">
								<span>{{ row1.index + 1 }}</span>
							</template>

							<template slot="taskNo" slot-scope="row2">
								<span>{{ row2.item.AMTSeries }}</span>
							</template>

							<template slot="expense" slot-scope="row3">
								<span>{{ row3.item.ledger }}</span>
							</template>

							<template slot="expAmount" slot-scope="row4">
								<span>{{ row4.item.amount }}</span>
							</template>

							<template slot="billToCustomer" slot-scope="row5">
								<span>{{ row5.item.scCategory }}</span>
							</template>

							<template slot="sellingAmount" slot-scope="row6">
								<span>{{ row6.item.selling_amt }}</span>
							</template>

							<template slot="remark" slot-scope="row7">
								<span>{{ row7.item.remark }}</span>
							</template>

							<template slot="addedOn" slot-scope="row8">
								<span>{{ row8.item.loginTime }}</span>
							</template>

							<template slot="addedBy" slot-scope="row9">
								<span>{{ row9.item.createdBy }}</span>
							</template>
						</b-table>
					</div>
				</div>


				<!-- Sline Payment Table -->
				<!-- {{ SlinePayment_Data }} <br> -->
				<!-- {{ selectedSlinePaymentRows }} <br> -->
				<div class="gutr">
					<h5> <b-badge variant="info">Sline Payment Details</b-badge> </h5>
					<div class="table-responsive tableMain">
						<b-table 
							show-empty stacked="md" 
							:items="SlinePayment_Data" 
							:fields="SlinePaymentFields"
						>
							<template slot="select" slot-scope="row0">
								<b-form-checkbox 
									v-model="selectedSlinePaymentRows" 
									:id="'checkboxSlinePayment_' + row0.index"
									:value="row0.item" 
									@change="addToFinalTable(row0.item)"
								></b-form-checkbox>
							</template>

							<template slot="sn" slot-scope="row1">
								<span>{{ row1.index + 1 }}</span>
							</template>

							<template slot="invoiceNo" slot-scope="row2">
								<a style="color: blue" v-if="row2.item.SlineUpload"
									href="javascript:void(0)" @click="openSignedDocument(`ASSIGNMENT_UPLOADS/${Filter.AssNo.replaceAll('/', '_')}/${row2.item.SlineUpload.replaceAll('/', '_')}`)">
									<b><u>{{ row2.item.SlineInvNo }}</u></b>
								</a>
							</template>

							<template slot="invoiceCategory" slot-scope="row3">
								<span>{{ row3.item.SlineInvCategory }}</span>
							</template>

							<template slot="invoiceType" slot-scope="row4">
								<span>{{ row4.item.newSlineInvType }}</span>
							</template>

							<template slot="invoiceAmount" slot-scope="row5">
								<span>{{ row5.item.SlineInvAmount }}</span>
							</template>

							<template slot="blno" slot-scope="row14">
								<span>{{ row14.item.SlineBlNo }}</span>
							</template>

							<template slot="paymentMode" slot-scope="row6">
								<span v-if="row6.item.SlineInvPayMode == 1">RTGS</span>
								<span v-else-if="row6.item.SlineInvPayMode == 2">Cheque</span>
								<span v-else></span>
							</template>

							<template slot="paymentReferenceNo" slot-scope="row7">
								<span>{{ row7.item.SlineInvPayRef }}</span>
							</template>

							<template slot="paymentAmount" slot-scope="row8">
								<span>{{ row8.item.SlineInvPaidAmount }}</span>
							</template>

							<template slot="paymentDate" slot-scope="row9">
								<span>{{ row9.item.SlineInvPayDate }}</span>
							</template>

							<template slot="paymentStatus" slot-scope="row10">
								<span v-if="row10.item.SlineInvPayStatus == 1" class="warning">Partial</span>
								<span v-else-if="row10.item.SlineInvPayStatus == 2" class="success">Completed</span>
								<span v-else class="error">Pending</span>
							</template>

							<template slot="billToShipper" slot-scope="row11">
								<span>{{ row11.item.scCategory }}</span>
							</template>

							<template slot="billToShipperRemark" slot-scope="row12">
								<span>{{ row12.item.scremark }}</span>
							</template>

							<template slot="addedBy" slot-scope="row13">
								<span>{{ row13.item.employeeName }}</span>
							</template>
						</b-table>
					</div>
				</div>


				<!-- Expense Document Table -->
				<!-- {{ ExpenseDoc_Data }} <br> -->
				<!-- {{ selectedExpenseRows }} <br> -->
				<div class="gutr">
					<h5> <b-badge variant="info">Expense Document Details</b-badge> </h5>
					<div class="table-responsive tableMain">
						<b-table 
							show-empty 
							stacked="md" 
							:items="ExpenseDoc_Data" 
							:fields="ExpenseDocFields"
						>
							<template slot="select" slot-scope="row0">
								<b-form-checkbox 
									v-model="selectedExpenseRows" 
									:id="'checkboxExpense_' + row0.index" 
									:value="row0.item"
									@change="addToFinalTable(row0.item)"
								></b-form-checkbox>
							</template>

							<template slot="sn" slot-scope="row1">
								<span>{{ row1.index + 1 }}</span>
							</template>

							<template slot="expenseDate" slot-scope="row2">
								<span>{{ row2.item.expenseDate }}</span>
							</template>

							<template slot="view" slot-scope="row3">
								<a style="color: blue" v-if="row3.item.documentLink"
									href="javascript:void(0)" @click="openSignedDocument(`ASSIGNMENT_UPLOADS/${Filter.AssNo.replaceAll('/', '_')}/${row3.item.documentLink.replaceAll('/', '_')}`)">
									<b><u>{{ row3.item.otherDocName }}</u></b>
								</a>
							</template>

							<template slot="remark" slot-scope="row6">
								<span>{{ row6.item.docRemarks }}</span>
							</template>

							<template slot="docAddingTime" slot-scope="row7">
								<span>{{ row7.item.doc_added_date }}</span>
							</template>

							<template slot="docAddedBy" slot-scope="row8">
								<span>{{ row8.item.employeeName }}</span>
							</template>
						</b-table>
					</div>
				</div>


				<!-- Final Tally Table -->
				<!-- {{ finalTableRows }} <br> -->
				<!-- {{ selectedFinalRows }} <br> -->
				<div class="gutr">
					<h5> <b-badge variant="info">Charges</b-badge> </h5>
					<table
						id="quotationDetail"
						class="table table-responsive-lg mt-3 table-light table-bordered shadow p-3 mb-5 bg-white rounded"
					>
						<tbody >
							<tr class="tableheaderStyling">
								<th>Select</th>
								<th>SN.</th>
								<th>Expense Type</th>
								<th>Vendor Name</th>
								<th>Vendor GST</th>
								<th>Particulars</th>
								<th>Expense No</th>
								<th>Expense Amount</th>
								<th>Expense Date</th>
								<th>Remarks</th>		
							</tr>

							<tr v-for="(item, index) in finalTableRows" :key="index">

								<!-- Checkbox -->
								<td>
									<b-form-checkbox 
										v-model="selectedFinalRows" 
										:id="'checkboxFinalTable_' + index"
										:value="item"
									></b-form-checkbox>
								</td>
								
								<td>{{ index + 1 }}</td>

								<td>
									<!-- Data from AMT table -->
									<model-list-select
										isDisabled v-if="item.expenseTypeAMT != undefined" 
										:list="expenseType"
										v-model="item.expenseTypeAMT" 
										option-value="expVal"
										option-text="expText"
									></model-list-select>

									<!-- Data from Sline table -->
									<model-list-select 
										isDisabled v-if="item.expenseTypeSline != undefined" 
										:list="expenseType"
										v-model="item.expenseTypeSline" 
										option-value="expVal" 
										option-text="expText"
									></model-list-select>

									<!-- Data from doc table -->
									<model-list-select 
										isDisabled v-if="item.expenseTypeDoc != undefined" 
										:list="expenseType"
										v-model="item.expenseTypeDoc" 
										option-value="expVal" 
										option-text="expText"
									></model-list-select>
								</td>

								<!-- Vendor Name -->
								<td>
									<model-list-select
									  :list="$store.getters['commonDropdownMaster/getAllTallyVendorList']"
										id="vendor_id" 
										v-model="item.vendorName"
										option-value="vendor_id"
										option-text="vendor_LglNm"
										placeholder="Select Vendor"
										@input="GstDataGet(item.vendorName, index)"
									></model-list-select>
									<span class="error" v-if="!item.vendorName">{{ vendorNameError }}</span>
								</td>

								<!-- Vendor Gst -->
								<td>
									<model-list-select
										v-if="item.getAllTallyVendorGstList"
										:list="item.getAllTallyVendorGstList" 
										id="vendor_add_id"
										v-model="item.vendorGst"
										option-value="vendor_add_id" 
										option-text="Gstnumber"
										placeholder="Select Vendor GST"
									></model-list-select>
									<span class="error" v-if="!item.vendorGst">{{ vendorGstError }}</span>
								</td>

								<!-- Particulars -->
								<td>
									<!-- Data from AMT table -->
									<b-form-input 
										disabled 
										v-if="item.ledger != undefined" 
										:formatter="capitalizeAll"
										v-model="item.ledger"
									></b-form-input>

									<!-- Data from Sline table -->
									<b-form-input 
										disabled 
										v-if="item.newSlineInvType != undefined" 
										:formatter="capitalizeAll"
										v-model="item.newSlineInvType"
									></b-form-input>

									<!-- Data from doc table -->
									<b-form-input 
										disabled 
										v-if="item.documentName != undefined" 
										:formatter="capitalizeAll"
										v-model="item.documentName"
									></b-form-input>
								</td>

								<!-- Expense No -->
								<td>
									<!-- Data from AMT table -->
									<b-form-input 
										disabled 
										v-if="item.AMTSeries != undefined" 
										:formatter="capitalizeAll"
										v-model="item.AMTSeries"
									></b-form-input>

									<!-- Data from Sline table -->
									<b-form-input 
										disabled v-if="item.SlineInvNo != undefined" 
										:formatter="capitalizeAll"
										v-model="item.SlineInvNo"
									></b-form-input>

									<!-- Data from doc table -->
									<b-form-input 
										v-if="item.AMTSeries == undefined && item.SlineInvNo == undefined"
										:formatter="capitalizeAll" 
										v-model="item.invoiceNo" 
										placeholder="Enter Invoice No"
									></b-form-input>
									<span class="error" v-if="!item.invoiceNo">{{ invoiceNoError }}</span>
								</td>
				
								<!-- Expense Amount -->
								<td>
									<!-- Data from AMT table -->
									<b-form-input 
										disabled v-if="item.amount != undefined" 
										:formatter="capitalizeAll"
										v-model="item.amount"
									></b-form-input>

									<!-- Data from Sline table -->
									<b-form-input 
										disabled
										v-if="item.SlineInvAmount != undefined" 
										:formatter="capitalizeAll"
										v-model="item.SlineInvAmount"
									></b-form-input>

									<!-- Data from doc table -->
									<b-form-input 
										v-if="item.SlineInvAmount == undefined && item.amount == undefined"
										:formatter="capitalizeAll" 
										v-model="item.expInvoiceAmount"
										placeholder="Enter Invoice Amount"
										type="number"
										min="1"
									></b-form-input>
									<span class="error" v-if="!item.expInvoiceAmount">{{ invoiceAmountError }}</span>
								</td>

								<!-- Expense date -->
								<td>
									<!-- Data from AMT table -->
									<b-form-input 
										disabled 
										v-if="item.doc_added_date != undefined"
										:formatter="capitalizeAll"
										v-model="item.doc_added_date"
									></b-form-input>

									<!-- Data from Sline table -->
									<b-form-input
										disabled
										v-if="item.SlineInvPayDate != undefined"
										:formatter="capitalizeAll"
										v-model="item.SlineInvPayDate"
									></b-form-input>

									<!-- Data from doc table -->
									<b-form-input 
										disabled 
										v-if="item.loginTime != undefined"
										:formatter="capitalizeAll"
										v-model="item.loginTime"
									></b-form-input>
								</td>

								<!-- Remark -->
								<td>
									<!-- Data from AMT table -->
									<b-form-input 
										disabled
										v-if="item.remark != undefined" 
										:formatter="capitalizeAll"
										v-model="item.remark"
									></b-form-input>

									<!-- Data from Sline table -->
									<b-form-input 
										v-if="item.remark == undefined && item.docRemarks == undefined"
										:formatter="capitalizeAll" 
										v-model="item.slineRemark"
										placeholder="enter remark if any..."
									></b-form-input>

									<!-- Data from doc table -->
									<b-form-input 
										disabled 
										v-if="item.docRemarks != undefined" 
										:formatter="capitalizeAll"
										v-model="item.docRemarks"
									></b-form-input>
								</td>
							</tr>

							<!-- <tr v-if="ffTallyInvoiceData.length > 0">
								<td colspan="8"></td>
								<td colspan="2">
									<b>Total :</b>
									<span>
										<b>{{ "total amount" }}</b>
									</span>
								</td>
								<td></td>
							</tr> -->

							<tr v-if="finalTableRows.length <= 0">
								<td colspan="10" style="text-align:center; font-size:14px; padding:1%;"> 
									<span class="warning"><b> No Expenses Selected, Select the above expenses to add charges </b></span>
								</td>
							</tr>
						</tbody>
					</table>

				</div>

				<div>
					<b-row class="gutr">
						<b-col md="2">
							<label>Job No.</label>
							<b-form-input :formatter="capitalizeAll" disabled id="jobNo" name="jobNo"
								v-model="Filter.AssNo"></b-form-input>
						</b-col>

						<b-col md="2">
							<label>Client GSTN</label>
							<b-form-input :formatter="capitalizeAll" id="clientGstn" name="clientGstn"
								v-model="Filter.clientGst"></b-form-input>
						</b-col>

						<b-col md="1">
							<label>State Code</label>
							<b-form-input type="number" :formatter="capitalizeAll" id="stateCode" name="stateCode"
								v-model="Filter.stateName"></b-form-input>
						</b-col>

					</b-row>

					<b-row class="gutr">
						<b-col md="6">
							<label>Client Address</label>
							<b-form-textarea :formatter="capitalizeAll" id="clientRegistrationNo" name="clientRegistrationNo"
								v-model="Filter.corporateAddress"></b-form-textarea>
						</b-col>

						<b-col md="2">
							<label>Pickup Location</label>
							<b-form-input :formatter="capitalizeAll" id="pickupLocation" name="pickupLocation"
								v-model="Filter.raisedFrom"></b-form-input>
						</b-col>

						<b-col md="2">
							<label>Handover Location</label>
							<b-form-input :formatter="capitalizeAll" id="handoverLocation" name="handoverLocation"
								v-model="Filter.Handover"></b-form-input>
						</b-col>

						<b-col md="2">
							<label>Factory Location</label>
							<b-form-input :formatter="capitalizeAll" id="factorLocation" name="factorLocation"
								v-model="Filter.factoryLoc"></b-form-input>
						</b-col>
					</b-row>

					<b-row class="gutr">
						<b-col md="3">
							<label>Place Of Receipt</label>
							<b-form-input :formatter="capitalizeAll" id="placeOfReceipt" name="placeOfReceipt"
								v-model="Filter.POR"></b-form-input>
						</b-col>

						<b-col md="3">
							<label>Load Port</label>
							<b-form-input :formatter="capitalizeAll" id="loadPort" name="loadPort"
								v-model="Filter.LP"></b-form-input>
						</b-col>

						<b-col md="2">
							<label>Final Place of Delivery</label>
							<b-form-input :formatter="capitalizeAll" id="finalPlaceOfDel" name="finalPlaceOfDel"
								v-model="Filter.FPOD"></b-form-input>
						</b-col>

						<b-col md="4">
							<label>Port Of Discharge</label>
							<b-form-input :formatter="capitalizeAll" id="portOfDischarge" name="portOfDischarge"
								v-model="Filter.POD"></b-form-input>
						</b-col>
					</b-row>

					<b-row class="gutr">
						<b-col md="3">
							<label>Shipping Line Name</label>
							<b-form-input :formatter="capitalizeAll" id="slineName" name="slineName"
								v-model="Filter.shippingLine"></b-form-input>
						</b-col>

						<b-col md="3">
							<label>Vessel / Voyage</label>
							<b-form-input :formatter="capitalizeAll" id="vessel" name="vessel"
								v-model="Filter.vessel"></b-form-input>
						</b-col>

						<b-col md="2">
							<label>Container Type</label>
							<b-form-input :formatter="capitalizeAll" id="multipleContainerType" name="multipleContainerType"
								v-model="Filter.ContainerType"></b-form-input>
						</b-col>

						<b-col md="3">
							<label>Container No.</label>
							<b-form-input :formatter="capitalizeAll" id="containerNo" name="containerNo"
								v-model="Filter.Container"></b-form-input>
						</b-col>

						<b-col md="1">
							<label>Weight (KGS)</label>
							<b-form-input type="number" :formatter="capitalizeAll" id="weight" name="weight"
								v-model="Filter.weight"></b-form-input>
						</b-col>
					</b-row>

					<b-row class="gutr">
						<b-col md="3">
							<label>Shipping Bill No/ Date</label>
							<b-form-input :formatter="capitalizeAll" id="shippingBill" name="shippingBill"
								v-model="Filter.SB"></b-form-input>
						</b-col>

						<b-col md="3">
							<label>Shipper Invoice No.</label>
							<b-form-input :formatter="capitalizeAll" id="shippingInv" name="shippingInv"
								v-model="Filter.shiperInv"></b-form-input>
						</b-col>

						<b-col md="2">
							<label>Shipper Invoice Date</label>
							<b-form-input :formatter="capitalizeAll" id="shippingInvDate" name="shippingInvDate"
								v-model="Filter.shipperInvDate"></b-form-input>
						</b-col>

						<b-col md="2">
							<label>BL No</label>
							<b-form-input type="number" :formatter="capitalizeAll" id="blNo" name="blNo"
								v-model="Filter.blNo"></b-form-input>
						</b-col>
					</b-row>

					<div class="gutr">
						<Profit-Loss 
							v-if="allModuleId" 
							:PMS_fk_all_module_id="allModuleId" 
							:PMS_jb_series="Filter.AssNo"
							:PMS_fk_client_id="Filter.TPTClient" 
							:PLAccordianStatus="false" 
							:PLAccordianButton="true" 
						/>

						<Assignment-Timeline 
							:TMAccordianStatus="false" 
							:TMAccordianButton="true"
							:allModuleId="Number(allModuleId)"
						/>
					</div>

					<md-layout md-gutter class="mrgtop-2per gutr mt-5">

						<md-layout md-flex="35"></md-layout>
						<md-layout md-flex="30">
							<b-button 
								block 
								v-if="allModuleId == this.$route.params.allModuleId" 
								variant="primary" 
								id="addButtonLoader"
								@click="submitTallyData()"
							>
								{{ allModuleId != "" ? "Update" : "Send Data To Tally" }}
							</b-button>

							<md-spinner md-indeterminate id="loader" style="display: none"></md-spinner>

						</md-layout>
					</md-layout>
				</div>
			</b-card-text>
		</b-card>
	</div>
</template>

<script>
import axios from "axios";
import DatePicker from "vue2-datepicker";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
import SplitmergeSummary from "../common/splitmergeSummary.vue";
import BannerComponent from "../allModuleForm/bannerComponent.vue";
import CommonService from "../../services/CommonService.js";
import ProfitLoss from "../common/profitLoss.vue";
import AssignmentTimeline from "../common/assignmentTimeline.vue";
import PaymentSummary from "../common/paymentSummary.vue";

export default {
	beforeMount() {

		if (globalPermissionStatus("Accounts")) {

			this.$store.dispatch("setCurrentRoute", this.$route.path);

			this.$store.dispatch(
				"common/setAllClientList",
				JSON.stringify({
					itemCode: "ClientList",
				})
			);

			this.$store.dispatch(
				"commonDropdownMaster/setAllTallyVendorDDList",
				JSON.stringify({
					itemCode: "All_Vendor_List",
					Filter: { statusFilter: "1" },
					type: "Normal",
				})
			);

			this.$store.dispatch(
				"common/setAllLedgerList",
				JSON.stringify({
					itemCode: "LedgerList",
				})
			);

			this.getAllPurchasesList('Normal');
			this.getAllTallyExpenseList();

			if (this.allModuleId != "") {
				this.getPaymentSummaryData();
			}
		} else {
			this.$router.push({
				path: "/dashboard",
			});
		}


	},

	data() {
		return {
			selectedATDRows: [],
			otherAdditionalTask_Data: [],
			AdditionalTaskFields: [
				{
					key: "select",
					label: "Select",
					sortable: true,
					sortDirection: "desc"
				},
				{
					key: "sn",
					label: "SN.",
					sortable: true,
					sortDirection: "desc"
				},
				{
					key: "taskNo",
					label: "Task No.",
					sortable: true,
					sortDirection: "desc"
				},
				{
					key: "expense",
					label: "Expense",
					sortable: true,
					sortDirection: "desc"
				},
				{
					key: "expAmount",
					label: "Expense Amount",
					sortable: true,
					sortDirection: "desc"
				},
				{
					key: "billToCustomer",
					label: "Bill to Customer",
					sortable: true,
					sortDirection: "desc"
				},
				{
					key: "sellingAmount",
					label: "Selling Amount",
					sortable: true,
					sortDirection: "desc"
				},
				{
					key: "remark",
					label: "Remark",
					sortable: true,
					sortDirection: "desc"
				},
				{
					key: "addedOn",
					label: "Added On",
					sortable: true,
					sortDirection: "desc"
				},
				{
					key: "addedBy",
					label: "Added By",
					sortable: true,
					sortDirection: "desc"
				}
			],

			selectedSlinePaymentRows: [],
			SlinePayment_Data: [],
			SlinePaymentFields: [
				{
					key: "select",
					label: "Select",
					sortable: true,
					sortDirection: "desc"
				},
				{
					key: "sn",
					label: "SN.",
					sortable: true,
					sortDirection: "desc"
				},
				{
					key: "invoiceNo",
					label: "Invoice No",
					sortable: true,
					sortDirection: "desc"
				},
				{
					key: "invoiceCategory",
					label: "Invoice Category",
					sortable: true,
					sortDirection: "desc"
				},
				{
					key: "invoiceType",
					label: "Invoice Type",
					sortable: true,
					sortDirection: "desc"
				},
				{
					key: "invoiceAmount",
					label: "Invoice Amount",
					sortable: true,
					sortDirection: "desc"
				},
				{
					key: "blno",
					label: "BL No.",
					sortable: true,
					sortDirection: "desc"
				},
				{
					key: "paymentMode",
					label: "Payment Mode",
					sortable: true,
					sortDirection: "desc"
				},
				{
					key: "paymentReferenceNo",
					label: "Payment Reference No",
					sortable: true,
					sortDirection: "desc"
				},
				{
					key: "paymentAmount",
					label: "Payment Amount",
					sortable: true,
					sortDirection: "desc"
				},
				{
					key: "paymentDate",
					label: "Payment Date",
					sortable: true,
					sortDirection: "desc"
				},
				{
					key: "paymentStatus",
					label: "Payment Status",
					sortable: true,
					sortDirection: "desc"
				},
				{
					key: "billToShipper",
					label: "Bill to Shipper",
					sortable: true,
					sortDirection: "desc"
				},
				{
					key: "billToShipperRemark",
					label: "Bill to Shipper remark",
					sortable: true,
					sortDirection: "desc"
				},
				{
					key: "addedBy",
					label: "Added By",
					sortable: true,
					sortDirection: "desc"
				}
			],

			selectedExpenseRows: [],
			ExpenseDoc_Data: [],
			ExpenseDocFields: [
				{
					key: "select",
					label: "Select",
					sortable: true,
					sortDirection: "desc"
				},
				{
					key: "sn",
					label: "SN.",
					sortable: true,
					sortDirection: "desc"
				},
				{
					key: "expenseDate",
					label: "Expense Date",
					sortable: true,
					sortDirection: "desc"
				},
				{
					key: "view",
					label: "View",
					sortable: true,
					sortDirection: "desc"
				},
				{
					key: "remark",
					label: "Remark",
					sortable: true,
					sortDirection: "desc"
				},
				{
					key: "docAddingTime",
					label: "Doc Adding Time",
					sortable: true,
					sortDirection: "desc"
				},
				{
					key: "docAddedBy",
					label: "Doc Added By",
					sortable: true,
					sortDirection: "desc"
				}
			],

			invoiceNoError: "",
			invoiceAmountError: "",
			vendorGstError: "",
			vendorNameError: "",

			selectedFinalRows: [],
			finalTableRows: [],

			expenseType: [
				{
					expVal: "additionalTask",
					expText: "Additional Task",
				},
				{
					expVal: "slinePay",
					expText: "Sline Pay",
				},
				{
					expVal: "expenseDoc",
					expText: "Expense Doc",
				},
			],


			allpurchasesList: [],
			newJobType: [],
			clientData: [],
			ledgerData: [],
			tallyExpenseList: [],

			validate: true,

			classId: "",
			allModuleId: this.$route.params.allModuleId,

			isLoading: false,
			totalRows: "",
			singleType: true,
			jobNo: "",
			showMoreNewItem: true,
			otherClientChecked: false,
			vendorNamError: "",
			tallyBillingSeries: 1,


			clientTypeList: [
				{
					inv: "1",
					int: "Client",
				},
				{
					inv: "2",
					int: "Oversea Agent",
				},
         {
          type: "Consignee",
          val: "4",
        },
			],

			confirm: {
				title: "Confirmation..!",
				contentHtml: "Data",
				ok: "Send",
				cancel: "Cancel",
			},

			filter: null,
			Filter: {

				AssNo: "",
				TPTClient: "",

				clientId: "",
				InvoiceNo: "",
				SB: "",
				POR: "",
				POD: "",
				containerType: "",
				shippingLine: "",
				Container: "",
				shiperInv: "",
				assignment: "",
				jobType: "",
				branch: "",
				status: "",
				SOB: "",
				Billing: "",
				jobRec: "",

				billingLocationId: "",
				finalBillingCompleted: "",
				billingLocationName: "",
				invoiceForClient: "",
				contactNo: "",
				clientGst: "",
				stateName: "",
				corporateAddress: "",
				Handover: "",
				raisedFrom: "",
				LP: "",
				vessel: "",
				shipperInvDate: "",
				blNo: "",
				weight: "",
				otherClientChecked: "",
				dateRange: { startDate: "", endDate: "" },
			},

		};
	},

	filters: {
		moment(date) {
			return DateFormat(date);
		},
	},

	components: {
		ModelListSelect,
		DatePicker,
		// Loading,
		 CustomLoader,
		SplitmergeSummary,
		BannerComponent,
		PaymentSummary,
		ProfitLoss,
		AssignmentTimeline
	},

	watch: {},

	methods: {
		addToFinalTable(item) {
			const index = this.finalTableRows.findIndex(el => el === item);
			if (index === -1) {
				this.finalTableRows.push(item);
			} else {
				this.finalTableRows.splice(index, 1);
			}
		},

		validateInvoice() {
			let validate_new = true;

			let i = 0;
			let errCount = 0;
			let arryToValidate = this.finalTableRows;

			for (let j = 0; j < arryToValidate.length; j++) {

				if (!arryToValidate[j].vendorName) {
					this.vendorNameError = "Vendor Name Required";
					validate_new = false;
					++errCount;
					break;
				} else {
					validate_new = true;
				}

				if (!arryToValidate[j].vendorGst) {
					this.vendorGstError = "Vendor GST Required";
					validate_new = false;
					++errCount;
					break;
				} else {
					validate_new = true;
				}

				if (!arryToValidate[j].invoiceNo) {
					this.invoiceNoError = "Invoice No. Required";
					validate_new = false;
					++errCount;
					break;
				} else {
					validate_new = true;
				}

				if (!arryToValidate[j].expInvoiceAmount) {
					this.invoiceAmountError = "Invoice Amount Required";
					validate_new = false;
					++errCount;
					break;
				} else {
					validate_new = true;
				}
				
				if (errCount > 0) {
					this.validateINV = false;
				}

				if (validate_new != true) {
					this.validate = false;
				} else {
					this.validate = true;
				}
			}
		},

		submitTallyData() {
			this.validateInvoice();
		},

		getAllPurchasesList(type) {
			this.tallyExpenseList = [];
			this.allpurchasesList = [];
			this.isLoading = true;
			this.totalRows = 0;

			let payload = {
				itemCode: "get_All_Purchases_List",
				Filter: {
					allModuleId: this.$route.params.allModuleId,
				},
				type: type,
				singleType: this.singleType,
			};
			
			CommonService.getAllPurchasesList(payload)
				.then((response) => {
					const { data, status, statusText } = response;
					if (status == 200 && data) {

						if (type == "Normal") {
							console.log("salil =>", data);
							if (data.allpurchasesList.length > 0) {
								console.log(data.allpurchasesList)

								this.allpurchasesList = data.allpurchasesList;
								this.totalRows = data.allpurchasesList.length;

								this.Filter.TPTClient = data.allpurchasesList[0].TPTClient;
								this.Filter.clientId = data.allpurchasesList[0].clientId;
								this.Filter.corporateAddress = data.allpurchasesList[0].corporateAddress;
								this.Filter.stateName = data.allpurchasesList[0].stateName;
								this.Filter.clientGst = data.allpurchasesList[0].GSTN;
								this.Filter.contactNo = data.allpurchasesList[0].contactNo;
								this.Filter.POD = data.allpurchasesList[0].POD;
								this.Filter.POR = data.allpurchasesList[0].POR;
								this.Filter.shiperInv = data.allpurchasesList[0].shipperInv;
								this.Filter.SB = data.allpurchasesList[0].ShippingB;
								this.Filter.shippingLine = data.allpurchasesList[0].shippingLine;
								this.Filter.raisedFrom = data.allpurchasesList[0].raisedFrom;
								this.Filter.billingLocationId = data.allpurchasesList[0].billingLocationId;
								this.Filter.finalBillingCompleted = data.allpurchasesList[0].finalBillingCompleted;


								if (this.$route.query.classId) {
									this.classId = this.$route.query.classId;
									this.Filter.AssNo = data.allpurchasesList[0].AssNo + "/" + this.classId;
								} else {
									this.Filter.AssNo = data.allpurchasesList[0].AssNo;
								}

								console.log(" getAllPurchasesList response=>", data);
							}
						}

					} else {
						this.allpurchasesList = [];
					}
					this.isLoading = false;
					this.PaginationCount = this.pagination.perPage;
				})
				.catch((error) => {
					console.log("Catch on getAllPurchasesList Error: ", error);
				});
		},

		getAllTallyExpenseList() {
			this.tallyExpenseList = [];
			this.isLoading = true;

			let payload = {
				itemCode: "get_All_Tally_Expense_Items_List",
				Filter: {
					allModuleId: this.$route.params.allModuleId,
				},
			};
			CommonService.getAllPurchasesList(payload)
				.then((response) => {
					const { data, status, statusText } = response;
					if (status == 200 && data) {

						if (data.tallyExpenseList.length > 0) {

							this.tallyExpenseList = data.tallyExpenseList;

							console.log(" tallyExpenseList response=>", data);
						}

					} else {
						this.tallyExpenseList = [];
					}
					this.isLoading = false;
				})

				.catch((error) => {
					console.log("Catch on tallyExpenseList Error: ", error);
				});
		},

		changeOtherClient() {
			let arryDone = this.clientData.filter((x) => {
				return x.clientId == this.Filter.clientId;
			});
			if (arryDone.length > 0) {
				this.Filter.TPTClient = arryDone[0].TPTClient;
				this.Filter.contactNo = arryDone[0].phoneKYC;
				this.Filter.clientGst = arryDone[0].gstCode + arryDone[0].GSTN;
				this.Filter.stateName = arryDone[0].stateName;
				this.Filter.corporateAddress = arryDone[0].corporateAddress;
			}

			if (this.allpurchasesList.length > 0) {
				if (
					this.allpurchasesList[0].clientId &&
					(this.allpurchasesList[0].clientId == this.Filter.clientId)
				)
					this.otherClientChecked = false;
			}
		},

		async GstDataGet(vendor_id, index) {
			console.log(vendor_id, "salil in GST function");

			await this.$store.dispatch(
				"commonDropdownMaster/setAllTallyVendorGstDDList",
				JSON.stringify({
						itemCode: "All_Vendor_GST_List",
						Filter: {
								statusFilter: "1",
								vendor_id: vendor_id,
						},
						type: "Normal",
				})
			);

			const updatedList = this.$store.getters['commonDropdownMaster/getAllTallyVendorGstList'];

			if (updatedList && updatedList.length > 0) {
				this.finalTableRows[index].getAllTallyVendorGstList = updatedList;
			} else {
				this.finalTableRows[index].getAllTallyVendorGstList = [];
			}
      this.$forceUpdate();
		},

		previousSalesView() {
			window.history.go(-1);
		},

		getPaymentSummaryData() {
			if (this.allModuleId != "") {
				let payload = {
					filter: "PaymentSummary",
					allModuleId: this.allModuleId,
				};

				let options = {
					method: "POST",
					url: `${URL_BASE}/Api_Common/viewAssignmentTrackDetails.php`,
					data: JSON.stringify(payload),
					crossDomain: true,
					headers: {
						Accept: "application/json",
						"Content-Type": "application/json",
						Authorization: this.$sessionsStorage.get("loginId"),
					},
				};

				axios(options)
					.then((result) => {
						const { statusText, status, data } = result;
						if (status == 200 && data) {

							this.otherAdditionalTask_Data = [];
							this.SlinePayment_Data = [];
							this.ExpenseDoc_Data = [];

							if (data.otherAdditionalTask_Data.length > 0) {
								this.$nextTick(() => {

									data.otherAdditionalTask_Data.forEach(item => {
										item.expenseTypeAMT = 'additionalTask';
									});

									this.otherAdditionalTask_Data = data.otherAdditionalTask_Data;

								});
							}

							if (data.SlinePayment_Data.length > 0) {
								this.$nextTick(() => {

									data.SlinePayment_Data.forEach(item => {
										item.expenseTypeSline = 'slinePay';
									});

									this.SlinePayment_Data = data.SlinePayment_Data;
								});
							}

							if (data.ExpenseDoc_Data.length > 0) {
								this.$nextTick(() => {

									data.ExpenseDoc_Data.forEach(item => {
										item.expenseTypeDoc = 'expenseDoc';
									});

									this.ExpenseDoc_Data = data.ExpenseDoc_Data;
								});
							}

						}
					})
					.catch((error) => { });
			}
		},
	},
};
</script>

<style>
.warning {
	color: orangered;
}

.success {
	color: green;
}

.error {
	color: red;
}

.tableheaderStyling{
	background-color: #002b49; 
	color: #fff; 
	font-weight: unset; 
	font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// singleExpenseDetails.vue?0a585f85